import { AxiosAdapter } from '../../../_config/adapters/axios/axios.adapter';
import { Http } from '../../../_config/adapters/axios/axios.protocols';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';

export class Service {
	async getData( status, page, pharmacy, limit = 20, quotation_type = 'magistral') {
		const data = { status, quotation_type };
		if (pharmacy !== null && pharmacy !== undefined) {
			data.pharmacy = pharmacy;
		}
		
		return new AxiosAdapter({
			method: Http.POST,
			url: `${Enviroment.QUOTATION}/${Enviroment.COUNTRY}/list`,
			params: { page:page, limit:limit },
			data: data
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}

	async getDataById(quotationId) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.QUOTATION}/${quotationId}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}


	async processNewStatus(body) {
		return new AxiosAdapter({
			method: Http.POST,
			url: `${Enviroment.QUOTATION}/tracking/${Enviroment.LANGUAGE}/process`,
			data: body,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async getPharmacies() {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FRONT_COMMON}/pharmacies/${Enviroment.LANGUAGE}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}

}
